<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<!-- dsfl;df -->
<div Class="subBlockContainer">
    <div class="subBlockContent">
        <child-header [title]="title" (closeEvent)="close()" [showDownload]="true" titleDownload="Transaction Summary" (downloadEvent)="downloadTransSummary()"></child-header>
        <div class="inner-subBlock-wrapper">
            <!-- <div class="page-title-wrapper">
                <div class="title blade-title-font">
                    {{title}}
                </div>
                <div class="basic-icon download-icon" placement="bottom" ngbTooltip="TRANSACTION SUMMARY"
                    (click)="downloadTransSummary()">
                </div>
                <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
            </div> -->
            <div *ngIf="loadContent">
                <div class="filter-wrapper" style="margin-bottom: 17px;">
                    <div class="col-lg-3">
                        <div class="searchInputGroup">
                            <div class="searchIcon">
                                <img src="../images/new_ui/filter.png">
                            </div>
                            <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                                onblur="this.placeholder='Filter'" [(ngModel)]="filterInput">
                        </div>
                    </div>
                    <!-- <div class="col-lg-9">
                        <button class="button button-red button-large" (click)="downloadTransSummary()">DOWNLOAD
                            TRANSACTION SUMMARY</button>
                    </div> -->
                </div>
                <!-- <div class="row tablePart d-block d-flex align-items-center">
                                <button (click)="downloadTransSummary()">DOWNLOAD TRANSACTION SUMMARY</button>
                        </div> -->
                <div class="shared-outer-wrapper d-block table-header-allign" *ngIf="ledger.statementTransactions">
                    <table matSort (matSortChange)="sortData($event)" class="white">
                        <thead>
                            <tr class="row">
                                <th mat-sort-header="date" class="col">DATE</th>
                                <th mat-sort-header="type" class="col">TYPE</th>
                                <th mat-sort-header="doc" class="col">DOC NO</th>
                                <th mat-sort-header="ref" class="col">REF</th>
                                <th mat-sort-header="yref" class="col">YOUR REF</th>
                                <th mat-sort-header="debited" class="col align-right">DEBITED</th>
                                <th mat-sort-header="credited" class="col align-right">CREDITED</th>
                                <th mat-sort-header="outstanding" class="col align-right">OUTSTANDING</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="shared-outer-wrapper d-block child-body" *ngIf="ledger.statementTransactions">
                    <table matSort (matSortChange)="sortData($event)" class="white">
                        <thead hidden="true">
                            <tr class="row">
                                <th mat-sort-header="date" class="col">DATE</th>
                                <th mat-sort-header="type" class="col">TYPE</th>
                                <th mat-sort-header="doc" class="col">DOC NO</th>
                                <th mat-sort-header="ref" class="col">REF</th>
                                <th mat-sort-header="yref" class="col">YOUR REF</th>
                                <th mat-sort-header="debited" class="col align-right">DEBITED</th>
                                <th mat-sort-header="credited" class="col align-right">CREDITED</th>
                                <th mat-sort-header="outstanding" class="col align-right">OUTSTANDING</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="row"
                                *ngFor="let trans of sortedData.statementTransactions  | TableFilterMultiple: ['transDate','transSortKey','transType','transReference'] : filterInput">
                                <td class="col">{{trans.transDate}}</td>
                                <td class="col align-center">{{trans.transType}}</td>
                                <td class="col align-center">{{trans.transSortKey}}</td>
                                <td class="col align-center">{{trans.transReference}}</td>
                                <td class="col align-right">{{trans.transDetails}}</td>
                                <td class="col align-right padding-r-x40">
                                    {{trans.transAmount == 0 ? '' : trans.transAmount | currency:'AUD':'symbol-narrow':'.2-2'}}
                                </td>
                                <td class="col align-right padding-r-x45">
                                    {{trans.transCredit == 0 ? '' : trans.transCredit | currency:'AUD':'symbol-narrow':'.2-2'}}
                                </td>
                                <td class="col align-right padding-r-x30">
                                    {{trans.transRefBalance == 0 ? '' : trans.transRefBalance | currency:'AUD':'symbol-narrow':'.2-2'}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row cards">
                    <div class="col-lg card">
                        <label>Overdue 2+ </label>
                        <span
                            class="price-wrapper">{{ledger.statementTotals.overDue2 | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                    </div>
                    <div class="col-lg card">
                        <label>Overdue 1 </label>
                        <span
                            class="price-wrapper">{{ledger.statementTotals.overDue1 | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                    </div>
                    <div class="col-lg card">
                        <label>Due Now </label>
                        <span
                            class="price-wrapper">{{ledger.statementTotals.overDue | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                    </div>
                    <div class="col-lg card">
                        <label>Current </label>
                        <span
                            class="price-wrapper">{{ledger.statementTotals.current | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                    </div>
                    <div class="col-lg card">
                        <label>Total </label>
                        <span
                            class="price-wrapper">{{ledger.statementTotals.balance | currency:'AUD':'symbol-narrow':'.2-2'}}</span>
                    </div>
                    <div class="col-lg card" *ngIf="showPayment">
                        <button
                            id="small-paymentBtn"
                            class="button button-red button-mid button-custom"
                            matTooltip="Requires Purchasing Permissions"
                            [matTooltipDisabled]="currentUserModel?.hasAdminAccess || currentUserModel?.hasPurchaseAccess"
                            [disabled]="!currentUserModel?.hasAdminAccess && !currentUserModel?.hasPurchaseAccess"
                            (click)="payAccountLedger(ledger?.statementTotals)"
                        >
                            Make a Payment
                        </button>
                        <div class="price-indicator">Prices Include GST.</div>
                    </div>
                </div>
            </div>
        </div>
        <loading-screen *ngIf="!loadContent" [showBlurTable]="false" (currentLoadingStatus)="onLoading($event)">
        </loading-screen>
    </div>
</div>

<!-- <div #entry></div> -->